window.addEventListener('DOMContentLoaded', (event) => {
  if (window.innerWidth > 1024) {
    const containers = document.querySelectorAll('.image-container');

    containers.forEach(container => {
      magnify(container);
    });
  }
});

function magnify(container) {
  const img = container.querySelector('img');
  let glass;

  /* Create magnifier glass */
  glass = document.createElement("DIV");
  glass.setAttribute("class", "img-magnifier-glass");
  container.appendChild(glass); // Append the magnifier glass to the container

  /* Set background properties for the magnifier glass */
  glass.style.backgroundImage = "url('" + img.src + "')";
  glass.style.backgroundRepeat = "no-repeat";

  img.onload = function() {
    glass.style.backgroundSize = (img.width * 3) + "px " + (img.height * 3) + "px";
  };

  container.addEventListener("mouseover", function(e) {
    glass.style.display = "block"; // Show magnifier glass on hover
    moveMagnifier(e);
  });

  container.addEventListener("mousemove", moveMagnifier);

  container.addEventListener("mouseout", function() {
    glass.style.display = "none"; // Hide magnifier glass when mouse leaves
  });

  function moveMagnifier(e) {
    const { offsetWidth: containerWidth, offsetHeight: containerHeight } = container;
    const { width: glassWidth, height: glassHeight } = glass.getBoundingClientRect();

    const posX = e.pageX - container.getBoundingClientRect().left - window.pageXOffset - glassWidth / 2;
    const posY = e.pageY - container.getBoundingClientRect().top - window.pageYOffset - glassHeight / 2;

    const x = posX < 0 ? 0 : posX > containerWidth - glassWidth ? containerWidth - glassWidth : posX;
    const y = posY < 0 ? 0 : posY > containerHeight - glassHeight ? containerHeight - glassHeight : posY;

    glass.style.left = x + "px";
    glass.style.top = y + "px";
    glass.style.backgroundPosition = `-${x * 3}px -${y * 3}px`;
  }
}
